"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5472],{

/***/ 16738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ executeHttp; }
});

// UNUSED EXPORTS: httpRequest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
// EXTERNAL MODULE: ./api/utils.ts
var utils = __webpack_require__(15374);
;// CONCATENATED MODULE: ./models/ApplicationErrors.ts





var HttpRequestError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(HttpRequestError, Error1);
    var _super = (0,_create_super/* default */.Z)(HttpRequestError);
    function HttpRequestError(status) {
        (0,_class_call_check/* default */.Z)(this, HttpRequestError);
        var _this;
        _this = _super.call(this);
        _this.status = status;
        return _this;
    }
    return HttpRequestError;
}((0,_wrap_native_super/* default */.Z)(Error));
var BadRequestError = /*#__PURE__*/ function(HttpRequestError) {
    "use strict";
    (0,_inherits/* default */.Z)(BadRequestError, HttpRequestError);
    var _super = (0,_create_super/* default */.Z)(BadRequestError);
    function BadRequestError(errors) {
        (0,_class_call_check/* default */.Z)(this, BadRequestError);
        var _this;
        _this = _super.call(this, utils/* ResponseStatuses.BadRequest */.nd.BadRequest);
        _this.errors = errors;
        return _this;
    }
    return BadRequestError;
}(HttpRequestError);
var AuthenticationError = /*#__PURE__*/ function(HttpRequestError) {
    "use strict";
    (0,_inherits/* default */.Z)(AuthenticationError, HttpRequestError);
    var _super = (0,_create_super/* default */.Z)(AuthenticationError);
    function AuthenticationError() {
        (0,_class_call_check/* default */.Z)(this, AuthenticationError);
        return _super.call(this, utils/* ResponseStatuses.Unauthorized */.nd.Unauthorized);
    }
    return AuthenticationError;
}(HttpRequestError);

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./api/auth.ts
var auth = __webpack_require__(93736);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./api/converter.ts




var isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;
var performTransformations = function(data) {
    if (typeof data === "string" && isoDateFormat.test(data)) {
        return new Date(data);
    } else return data;
};
var transformData = function(object) {
    var traverse = function(node) {
        if (Array.isArray(node)) {
            return node.map(function(entry) {
                return traverse(entry);
            });
        }
        if (typeof node === "object" && node) {
            return Object.entries(node).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, traverse(value)));
            }, {});
        }
        // leaf found
        return performTransformations(node);
    };
    return traverse(object);
};

;// CONCATENATED MODULE: ./api/http.ts










var _obj;
var defaultHeaders = (_obj = {}, (0,_define_property/* default */.Z)(_obj, utils/* Headers.Accept */.PM.Accept, utils/* ContentTypes.ApplicationJson */.bT.ApplicationJson), (0,_define_property/* default */.Z)(_obj, utils/* Headers.ContentType */.PM.ContentType, utils/* ContentTypes.ApplicationJson */.bT.ApplicationJson), _obj);
var formDataHeaders = (0,_define_property/* default */.Z)({}, utils/* Headers.Accept */.PM.Accept, utils/* ContentTypes.ApplicationJson */.bT.ApplicationJson);
// throwOnError should be set to true if using this in react query hook
var executeHttp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        var throwOnError, promise, data, e, errors;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    throwOnError = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    switch(config.endpoint.method){
                        case utils/* Methods.Get */.fq.Get:
                            promise = httpGet(config);
                            break;
                        case utils/* Methods.Post */.fq.Post:
                            promise = httpPost(config);
                            break;
                        case utils/* Methods.Put */.fq.Put:
                            promise = httpPut(config);
                            break;
                        case utils/* Methods.Patch */.fq.Patch:
                            promise = httpPatch(config);
                            break;
                        case utils/* Methods.Delete */.fq.Delete:
                            promise = httpDelete(config);
                            break;
                        default:
                            throw new Error("Method ".concat(config.endpoint.method, " is not supported!"));
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data
                        }
                    ];
                case 3:
                    e = _state.sent();
                    errors = [
                        constants/* GENERAL_ERROR */.PC
                    ];
                    if ((0,_instanceof/* default */.Z)(e, AuthenticationError)) (0,auth/* handleAuthenticationError */.tW)(location.pathname.startsWith("/portal") ? "DevPortal" : "Internal");
                    if ((0,_instanceof/* default */.Z)(e, BadRequestError)) errors = e.errors ? e.errors.map(function(error) {
                        return error.messages;
                    }).flat() : errors;
                    // react query requires that we throw an error in order to work properly
                    if (throwOnError) throw {
                        errors: errors
                    };
                    return [
                        2,
                        {
                            errors: errors
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function executeHttp(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpGet = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                httpRequest(utils/* Methods.Get */.fq.Get, config)
            ];
        });
    });
    return function httpGet(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpPost = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                httpRequest(utils/* Methods.Post */.fq.Post, config)
            ];
        });
    });
    return function httpPost(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpPut = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                httpRequest(utils/* Methods.Put */.fq.Put, config)
            ];
        });
    });
    return function httpPut(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpDelete = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                httpRequest(utils/* Methods.Delete */.fq.Delete, config)
            ];
        });
    });
    return function httpDelete(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpPatch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(config) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                httpRequest(utils/* Methods.Patch */.fq.Patch, config)
            ];
        });
    });
    return function httpPatch(config) {
        return _ref.apply(this, arguments);
    };
}();
var httpRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(method, param) {
        var headers, endpoint, body, queryParams, pathParams, isFormData, requestHeaders, accessToken, args, url, request, response, _, errorResponse, errors, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = param.headers, endpoint = param.endpoint, body = param.body, queryParams = param.queryParams, pathParams = param.pathParams;
                    isFormData = (0,_instanceof/* default */.Z)(body, FormData);
                    requestHeaders = (0,_object_spread/* default */.Z)({}, isFormData ? formDataHeaders : defaultHeaders, headers);
                    if (endpoint.authenticationType) {
                        if (!requestHeaders[utils/* Headers.Authorization */.PM.Authorization]) {
                            accessToken = (0,auth/* getAccessToken */.hP)(endpoint.authenticationType);
                            if (accessToken && accessToken.value) {
                                requestHeaders = (0,_object_spread/* default */.Z)({}, requestHeaders, (0,utils/* getBearerTokenAuthenticationHeader */.lK)(accessToken.value));
                            }
                        }
                    }
                    args = {
                        method: method,
                        body: isFormData ? body : JSON.stringify(body),
                        headers: requestHeaders
                    };
                    url = (0,utils/* getApiUrl */.kG)(endpoint, pathParams, queryParams);
                    request = new Request(url.toString(), args);
                    return [
                        4,
                        fetch(request)
                    ];
                case 1:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        6
                    ];
                    _ = response.status;
                    switch(_){
                        case utils/* ResponseStatuses.Unauthorized */.nd.Unauthorized:
                            return [
                                3,
                                2
                            ];
                        case utils/* ResponseStatuses.BadRequest */.nd.BadRequest:
                            return [
                                3,
                                3
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    throw new AuthenticationError();
                case 3:
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    errorResponse = _state.sent();
                    errors = errorResponse["errors"];
                    throw new BadRequestError(errors);
                case 5:
                    throw new HttpRequestError(response.status);
                case 6:
                    return [
                        4,
                        response.json()
                    ];
                case 7:
                    data = _state.sent();
                    return [
                        2,
                        transformData(data)
                    ];
            }
        });
    });
    return function httpRequest(method, _) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 57380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hv": function() { return /* binding */ endpoints; }
/* harmony export */ });
/* unused harmony exports AuthenticationType, Endpoint, apis, versions */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _models_AccessTokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34434);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15374);



var AuthenticationType = {
    AdminToken: _models_AccessTokens__WEBPACK_IMPORTED_MODULE_0__/* .AccessTokenType.JWT */ .T.JWT
};
var Endpoint = /*#__PURE__*/ function() {
    "use strict";
    function Endpoint(api, version, method, path, authenticationType) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Endpoint);
        this.api = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .padSlash */ .$g)(api);
        this.version = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .padSlash */ .$g)(version);
        this.path = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .padSlash */ .$g)(path);
        this.authenticationType = authenticationType;
        this.method = method;
    }
    var _proto = Endpoint.prototype;
    _proto.toString = function toString() {
        return this.api + this.version + this.path;
    };
    _proto.withPathParams = function withPathParams(pathParams) {
        var pathWithPathParams = this.path;
        Object.keys(pathParams).forEach(function(name) {
            pathWithPathParams = pathWithPathParams.replace("{".concat(name, "}"), pathParams[name]);
        });
        return new Endpoint(this.api, this.version, this.method, pathWithPathParams, this.authenticationType);
    };
    return Endpoint;
}();
var apis = {
    internal: "internal",
    public: "public"
};
var versions = {
    v0: "v0"
};
var endpoints = {
    internal: {
        v0: {
            // Token
            internalAdminToken: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "internal-admin-token"),
            // Partners
            createPartner: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "partners", AuthenticationType.AdminToken),
            editPartner: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "partners/{partnerId}", AuthenticationType.AdminToken),
            getPartner: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "partners/{partnerId}", AuthenticationType.AdminToken),
            listAllPartners: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "partners", AuthenticationType.AdminToken),
            deletePartner: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "partners/{partnerId}", AuthenticationType.AdminToken),
            // App developers
            createAppDeveloperInvite: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "app-developer/invites", AuthenticationType.AdminToken),
            getAppDeveloperInvites: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "app-developer/invites", AuthenticationType.AdminToken),
            getAppDevelopers: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "app-developer/partner/{partnerId}", AuthenticationType.AdminToken),
            createAppDeveloper: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "app-developer", AuthenticationType.AdminToken),
            editAppDeveloper: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "app-developer/{appDeveloperId}", AuthenticationType.AdminToken),
            getAppDeveloper: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "app-developer/{appDeveloperId}", AuthenticationType.AdminToken),
            deleteAppDeveloper: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "app-developer/{appDeveloperId}", AuthenticationType.AdminToken),
            // Apps
            createApp: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "apps", AuthenticationType.AdminToken),
            editApp: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "apps/{appId}", AuthenticationType.AdminToken),
            getApp: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/{appId}", AuthenticationType.AdminToken),
            listAllApps: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps", AuthenticationType.AdminToken),
            getAppsByPartnerId: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/partner/{partnerId}", AuthenticationType.AdminToken),
            getAppsForPartner: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/partner", AuthenticationType.AdminToken),
            deleteApp: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "apps/{appId}", AuthenticationType.AdminToken),
            accessKeySecret: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "apps/access-key-secret"),
            regenerateAccessKeySecret: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/apps/{appId}/regenerate-access-key-secret", AuthenticationType.AdminToken),
            updateWebOrigins: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Put */ .fq.Put, "/apps/{appId}/web-origins", AuthenticationType.AdminToken),
            getWebOrigins: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/apps/{appId}/web-origins", AuthenticationType.AdminToken),
            getAppProduct: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/apps/{appId}/app-product", AuthenticationType.AdminToken),
            assignAppProduct: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/apps/{appId}/app-product", AuthenticationType.AdminToken),
            invalidateAppProduct: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "/apps/{appId}/app-product", AuthenticationType.AdminToken),
            // Rate limits
            editLimit: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "apps/{appId}/ratelimiting", AuthenticationType.AdminToken),
            getLimit: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/{appId}/ratelimiting", AuthenticationType.AdminToken),
            // App auth config (ES Connect)
            getAppAuthConfig: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/{appId}/auth-config", AuthenticationType.AdminToken),
            getDeveloperAppAuthConfig: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "apps/{appId}/developer-auth-config", AuthenticationType.AdminToken),
            patchAppAuthConfig: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "apps/{appId}/auth-config", AuthenticationType.AdminToken),
            patchAppAuthConfigStatus: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "apps/{appId}/auth-config/status", AuthenticationType.AdminToken),
            postPartnerAppLogo: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "apps/{appId}/logo", AuthenticationType.AdminToken),
            putAppScopes: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Put */ .fq.Put, "apps/{appId}/auth-config/scopes", AuthenticationType.AdminToken),
            deletePartnerAppLogo: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "apps/{appId}/logo", AuthenticationType.AdminToken),
            // Tiers
            getAllTiers: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "tiers", AuthenticationType.AdminToken),
            getTier: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "tiers/{tierId}", AuthenticationType.AdminToken),
            createTier: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "tiers", AuthenticationType.AdminToken),
            editTier: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "tiers/{tierId}", AuthenticationType.AdminToken),
            deleteTier: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "tiers/{tierId}", AuthenticationType.AdminToken),
            // Collections
            getCollections: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/collections", AuthenticationType.AdminToken),
            getCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/collections/{collectionId}", AuthenticationType.AdminToken),
            createCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/collections", AuthenticationType.AdminToken),
            toggleCollectionStatus: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/collections/toggle", AuthenticationType.AdminToken),
            updateCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/collections/{collectionId}", AuthenticationType.AdminToken),
            deleteCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "/collections/{collectionId}", AuthenticationType.AdminToken),
            syncCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/collections/{collectionId}/sync", AuthenticationType.AdminToken),
            // Curated collections
            getCuratedCollections: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/curated-collections", AuthenticationType.AdminToken),
            getCuratedCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/curated-collections/{collectionId}", AuthenticationType.AdminToken),
            createCuratedCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/curated-collections", AuthenticationType.AdminToken),
            patchCuratedCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/curated-collections/{collectionId}", AuthenticationType.AdminToken),
            syncCuratedCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/curated-collections/{collectionId}/sync", AuthenticationType.AdminToken),
            deleteCuratedCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "/curated-collections/{collectionId}", AuthenticationType.AdminToken),
            // Templates
            getTemplates: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/app-catalog-templates", AuthenticationType.AdminToken),
            getTemplate: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/app-catalog-templates/{templateId}", AuthenticationType.AdminToken),
            createTemplate: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/app-catalog-templates", AuthenticationType.AdminToken),
            patchTemplate: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/app-catalog-templates/{templateId}", AuthenticationType.AdminToken),
            toggleTemplateCollection: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/app-catalog-templates/{templateId}/toggle", AuthenticationType.AdminToken),
            deleteTemplate: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Delete */ .fq.Delete, "/app-catalog-templates/{templateId}", AuthenticationType.AdminToken),
            //Products
            getProducts: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/product", AuthenticationType.AdminToken),
            createProduct: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Post */ .fq.Post, "/product", AuthenticationType.AdminToken),
            updateProduct: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Patch */ .fq.Patch, "/product/{productId}", AuthenticationType.AdminToken),
            getTrackHighlights: new Endpoint(apis.internal, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "tracks/{trackId}/highlights", AuthenticationType.AdminToken)
        }
    },
    public: {
        v0: {
            getCollections: new Endpoint(apis.public, versions.v0, _utils__WEBPACK_IMPORTED_MODULE_1__/* .Methods.Get */ .fq.Get, "/collections")
        }
    }
};


/***/ }),

/***/ 5472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ PlayerBar; }
});

// UNUSED EXPORTS: StyledIcon

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(47411);
// EXTERNAL MODULE: ./hooks/hooks.ts
var hooks = __webpack_require__(22699);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
// EXTERNAL MODULE: ./components/simpletable/TableColumnWithImageAndText.tsx
var TableColumnWithImageAndText = __webpack_require__(22411);
;// CONCATENATED MODULE: ./components/audio/PlayerActiveTrack.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    flex-basis: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 17rem;\n    min-width: 17rem;\n    display: flex;\n    align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledGreyDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1a466ac-0"
})(_templateObject(), constants/* COLORS.GRAY_2 */.DM.GRAY_2);
var StyledActiveTrackContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1a466ac-1"
})(_templateObject1());
var PlayerActiveTrack = function(param) {
    var track = param.track;
    var trackImage = track ? track.images.XS : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActiveTrackContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableColumnWithImageAndText/* TableColumnWithImageAndText */.s, {
            image: trackImage,
            imageAlt: track.title || "Track artwork",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: track.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGreyDiv, {
                    children: track === null || track === void 0 ? void 0 : track.mainArtists.join(", ")
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Typography/Typography.mjs
var Typography = __webpack_require__(73550);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Spinner/Spinner.mjs
var Spinner = __webpack_require__(34339);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Media/Waveform/Waveform.mjs + 1 modules
var Waveform = __webpack_require__(80937);
// EXTERNAL MODULE: ./utils/format.ts
var format = __webpack_require__(2766);
;// CONCATENATED MODULE: ./components/audio/ProgressWaveform.tsx

function ProgressWaveform_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    flex-basis: 30rem;\n    margin-left: 1rem;\n"
    ]);
    ProgressWaveform_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProgressWaveform_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-left: 1rem;\n"
    ]);
    ProgressWaveform_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 1rem;\n    display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Text = Typography/* Text */.xv;
var COLORS = constants/* COLORS */.DM;
var StyledWaveformWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52069bde-0"
})(ProgressWaveform_templateObject());
var StyledDurationText = (0,styled_components_browser_esm/* default */.ZP)(Text).withConfig({
    componentId: "sc-52069bde-1"
})(ProgressWaveform_templateObject1());
var StyledElapsedTimeText = (0,styled_components_browser_esm/* default */.ZP)(Text).withConfig({
    componentId: "sc-52069bde-2"
})(_templateObject2());
var ProgressWaveformWrapper = function(param) {
    var elapsedTime = param.elapsedTime, duration = param.duration, url = param.url, onSeekTo = param.onSeekTo, isLoading = param.isLoading;
    var ref = (0,react.useState)(), waveformData = ref[0], setWaveformData = ref[1];
    var loadWaveformDataCallback = (0,react.useCallback)(function() {
        fetch(url).then(function(response) {
            response.json().then(function(json) {
                setWaveformData(json.data);
            });
        });
    }, []);
    (0,react.useEffect)(function() {
        return loadWaveformDataCallback();
    }, []);
    var displayTime = function(sec) {
        return (0,format/* formatSecondsToMinutesAndSeconds */.Z)(Math.floor(sec));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWaveformWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledElapsedTimeText, {
                component: "div",
                children: displayTime(elapsedTime)
            }),
            waveformData && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressWaveform, {
                elapsedTime: elapsedTime,
                duration: duration,
                waveformData: waveformData,
                onSeekTo: onSeekTo
            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDurationText, {
                component: "div",
                color: COLORS.GRAY_2,
                children: displayTime(duration)
            })
        ]
    });
};
var ProgressWaveform = function(param) {
    var elapsedTime = param.elapsedTime, duration = param.duration, waveformData = param.waveformData, onSeekTo = param.onSeekTo;
    var progress = elapsedTime / duration;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Waveform/* default */.Z, {
            height: constants.WAVEFORM_HEIGHT,
            fillColor: COLORS.GRAY_2,
            strokeColor: COLORS.GRAY_2,
            waveformData: waveformData,
            onLoad: function(waveform) {
                return waveform.drawProgress(progress);
            },
            onClick: function(e) {
                var seekToSecond = e.nativeEvent.offsetX / e.currentTarget.clientWidth * duration;
                onSeekTo(seekToSecond);
            }
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Icon/Pause.mjs
var Pause = __webpack_require__(33501);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Icon/Play.mjs
var Play = __webpack_require__(9554);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Icon/Next.mjs
var Next = __webpack_require__(44703);
;// CONCATENATED MODULE: ./components/audio/PlayerControlButtons.tsx

function PlayerControlButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    > * {\n        margin-right: 1rem;\n        min-width: 2rem;\n        color: ",
        ";\n    }\n\n    i {\n        position: relative;\n    }\n\n    & svg:focus,\n    & svg:hover {\n        fill: ",
        ";\n    }\n"
    ]);
    PlayerControlButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlayerControlButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: stretch;\n    flex-basis: 5rem;\n"
    ]);
    PlayerControlButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PlayerControlButtons_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    align-items: stretch;\n    margin-right: 1rem;\n"
    ]);
    PlayerControlButtons_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var PlayerControlButtons_COLORS = constants/* COLORS */.DM;
var StyledPlayerControlButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9648851-0"
})(PlayerControlButtons_templateObject(), PlayerControlButtons_COLORS.WHITE, PlayerControlButtons_COLORS.GRAY_2);
var StyledPlayerControlButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9648851-1"
})(PlayerControlButtons_templateObject1());
var StyledProgressWaveform = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9648851-2"
})(PlayerControlButtons_templateObject2());
var PlayerControlButtons = function(param) {
    var track = param.track, playbackStatus = param.playbackStatus, onPlayPauseClick = param.onPlayPauseClick, onNextClick = param.onNextClick, elapsedTime = param.elapsedTime, duration = param.duration, onSeekTo = param.onSeekTo, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlayerControlButtonsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlayerControlButtons, {
                children: [
                    playbackStatus === "play" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pause/* Pause */.d, {
                        onClick: onPlayPauseClick,
                        status: playbackStatus,
                        "data-cy-player-control-button-pause": true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Play/* Play */.s, {
                        onClick: onPlayPauseClick,
                        status: playbackStatus
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Next/* Next */.o, {
                        onClick: onNextClick,
                        "data-cy-player-control-button-next": true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerActiveTrack, {
                track: track
            }),
            track.waveformUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressWaveform, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressWaveformWrapper, {
                    elapsedTime: elapsedTime,
                    duration: duration,
                    url: track.waveformUrl,
                    onSeekTo: onSeekTo,
                    isLoading: isLoading
                })
            })
        ]
    });
};
/* harmony default export */ var audio_PlayerControlButtons = (PlayerControlButtons);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./api/index.ts
var api = __webpack_require__(57380);
// EXTERNAL MODULE: ./api/http.ts + 2 modules
var http = __webpack_require__(16738);
// EXTERNAL MODULE: ./api/utils.ts
var utils = __webpack_require__(15374);
;// CONCATENATED MODULE: ./api/highlights.ts







var getTrackHighlights = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(trackId, accessToken) {
        var headers, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = (0,_define_property/* default */.Z)({}, utils/* Headers.Authorization */.PM.Authorization, "Bearer ".concat(accessToken));
                    return [
                        4,
                        (0,http/* executeHttp */.x)((0,_object_spread/* default */.Z)({
                            endpoint: api/* endpoints.internal.v0.getTrackHighlights */.Hv.internal.v0.getTrackHighlights,
                            pathParams: {
                                trackId: trackId
                            }
                        }, accessToken && {
                            headers: headers
                        }), true)
                    ];
                case 1:
                    data = _state.sent();
                    if (data.data && !Array.isArray(data.data.highlights)) {
                        throw new Error("Invalid data format received from portal highlights API");
                    }
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getTrackHighlights(trackId, accessToken) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
;// CONCATENATED MODULE: ./components/audio/Player.tsx









var useAudio = function(url, status, onStatusChange) {
    // https://www.erikverweij.dev/blog/building-a-minimal-audioplayer/
    var audioRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), currentTime = ref[0], setCurrentTime = ref[1];
    var ref1 = (0,react.useState)(0), duration = ref1[0], setDuration = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(1), currentVolume = ref3[0], setCurrentVolume = ref3[1];
    (0,react.useEffect)(function() {
        // A new url for track was provided!
        setLoading(true);
    }, [
        url
    ]);
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
            onLoadedData: function() {
                setLoading(false);
                if (audioRef.current) {
                    setDuration(audioRef.current.duration);
                    setCurrentVolume(audioRef.current.volume);
                }
            },
            src: url,
            ref: audioRef,
            onTimeUpdate: function() {
                audioRef.current && setCurrentTime(audioRef.current.currentTime);
            },
            onVolumeChange: function() {
                audioRef.current && setCurrentVolume(audioRef.current.volume);
            }
        }, "player"),
        {
            currentTime: currentTime,
            duration: duration,
            isLoading: isLoading,
            progress: currentTime / duration * 100,
            currentVolume: currentVolume,
            setVolume: function(v) {
                if (audioRef.current) audioRef.current.volume = v;
            },
            seekTo: function(seconds) {
                if (audioRef.current) audioRef.current.currentTime = seconds;
            },
            togglePlaybackStatus: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            switch(status){
                                case "play":
                                    return [
                                        3,
                                        1
                                    ];
                                case "pause":
                                    return [
                                        3,
                                        2
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            // Toggle from play -> pause and sync status with active track (track listning)
                            if (audioRef.current) {
                                audioRef.current.pause();
                                onStatusChange("pause");
                            }
                            return [
                                3,
                                5
                            ];
                        case 2:
                            if (!audioRef.current) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                audioRef.current.play()
                            ];
                        case 3:
                            _state.sent();
                            onStatusChange("play");
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }),
            setPlayerStatus: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(playerStatus) {
                    var _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(playerStatus){
                                    case "play":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "pause":
                                        return [
                                            3,
                                            4
                                        ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                _tmp = audioRef.current;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    audioRef.current.play()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                audioRef.current && audioRef.current.pause();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(playerStatus) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};
var Player = function(param) {
    var status = param.status, track = param.track, onStatusChange = param.onStatusChange, onNext = param.onNext;
    var ref = (0,_sliced_to_array/* default */.Z)(useAudio(track.url, status, onStatusChange), 2), audioElement = ref[0], audioProps = ref[1];
    var addError = (0,hooks/* useMessages */.y_)().addError;
    var startFromHighlights = (0,hooks/* useActiveTrack */.AP)().startFromHighlights;
    var ref1 = (0,next_auth_react.useSession)(), session = ref1.data;
    var ref2 = (0,react.useState)(null), highlights = ref2[0], setHighlights = ref2[1];
    var handleSeekTo = function(seconds) {
        audioProps.seekTo(seconds);
    };
    var nextTrackCallback = (0,react.useCallback)(function() {
        audioProps.togglePlaybackStatus();
        onNext();
    }, []);
    (0,react.useEffect)(function() {
        if (!highlights) return;
        audioProps.seekTo((highlights === null || highlights === void 0 ? void 0 : highlights.from) / 1000 || 0);
    }, [
        highlights
    ]);
    (0,react.useEffect)(function() {
        // Sync player status from external props
        audioProps.setPlayerStatus(status);
    }, [
        status
    ]);
    (0,react.useEffect)(function() {
        if (audioProps.currentTime !== 0 && audioProps.currentTime === audioProps.duration) {
            nextTrackCallback();
        }
    }, [
        audioProps.currentTime
    ]);
    (0,react.useEffect)(function() {
        var isMounted = true;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result, ref, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            // Pause the player while fetching highlights
                            onStatusChange("pause");
                            return [
                                4,
                                getTrackHighlights(track.id, session === null || session === void 0 ? void 0 : session.accessToken)
                            ];
                        case 1:
                            result = _state.sent();
                            if (isMounted) {
                                ;
                                if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.highlights[0])) {
                                    setHighlights(null);
                                } else {
                                    setHighlights(result.data.highlights[0]);
                                }
                            }
                            onStatusChange("play");
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            addError("Error fetching highlights");
                            onStatusChange("play");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (startFromHighlights && track.id) {
            fetchData();
        } else {
            setHighlights(null);
        }
        return function() {
            isMounted = false;
        };
    }, [
        track.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            audioElement,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(audio_PlayerControlButtons, {
                track: track,
                elapsedTime: audioProps.currentTime,
                duration: audioProps.duration,
                playbackStatus: status,
                onNextClick: nextTrackCallback,
                onPlayPauseClick: audioProps.togglePlaybackStatus,
                onSeekTo: handleSeekTo,
                isLoading: audioProps.isLoading
            })
        ]
    });
};
/* harmony default export */ var audio_Player = (Player);

// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Icon/Close.mjs
var Close = __webpack_require__(38833);
;// CONCATENATED MODULE: ./components/audio/PlayerBar.tsx

function PlayerBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 50px;\n    text-align: center;\n    padding: 1rem;\n    position: fixed;\n    bottom: 70px;\n    background: ",
        ";\n    width: 90%;\n    z-index: 1100;\n    left: 3rem;\n    color: ",
        ";\n    border-radius: 10px;\n    align-items: center;\n    display: ",
        ";\n"
    ]);
    PlayerBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlayerBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n\n    & svg:focus,\n    & svg:hover {\n        fill: ",
        ";\n    }\n"
    ]);
    PlayerBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var StyledPlayerBarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e3e0b676-0"
})(PlayerBar_templateObject(), constants/* COLORS.GRAY_1 */.DM.GRAY_1, constants/* COLORS.WHITE */.DM.WHITE, function(props) {
    return props.app === "Landingpage" ? "none" : "flex";
});
var StyledIcon = styled_components_browser_esm/* default.i.withConfig */.ZP.i.withConfig({
    componentId: "sc-e3e0b676-1"
})(PlayerBar_templateObject1(), constants/* COLORS.GRAY_2 */.DM.GRAY_2);
var PlayerBar = function(param) {
    var app = param.app;
    var ref = (0,hooks/* useActiveTrack */.AP)(), status = ref.status, setStatus = ref.setStatus, activeTrack = ref.activeTrack, stopTrack = ref.stopTrack;
    var nextTrack = (0,hooks/* usePlayerQueue */.Ww)().nextTrack;
    var ref1 = (0,react.useState)(false), isPlayNextTrack = ref1[0], setPlayNextTrack = ref1[1];
    (0,react.useEffect)(function() {
        if (isPlayNextTrack === false) return;
        stopTrack();
        var timeout = setTimeout(function() {
            nextTrack();
            setPlayNextTrack(false);
        }, 250);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isPlayNextTrack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: activeTrack && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlayerBarContainer, {
            "data-cy-player-bar": true,
            app: app,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(audio_Player, {
                    track: activeTrack,
                    status: status,
                    onStatusChange: function(status) {
                        return setStatus(status);
                    },
                    onNext: function() {
                        return setPlayNextTrack(true);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                        onClick: stopTrack,
                        "data-cy-hide-player-bar-button": true
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 91147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(47411);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
;// CONCATENATED MODULE: ./components/image/ImagePlaceholder.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    background: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledImagePlaceHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a58c76-0"
})(_templateObject(), function(props) {
    return props.width ? props.width + props.unit : "50px";
}, function(props) {
    return props.height ? props.height + props.unit : "50px";
}, constants/* COLORS.GRAY_2 */.DM.GRAY_2);
var ImagePlaceHolder = function(param) {
    var dimension = param.dimension, alt = param.alt, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImagePlaceHolder, {
        width: dimension === null || dimension === void 0 ? void 0 : dimension.width,
        height: dimension === null || dimension === void 0 ? void 0 : dimension.height,
        unit: (dimension === null || dimension === void 0 ? void 0 : dimension.unit) || "px",
        title: alt,
        onClick: onClick
    });
};

;// CONCATENATED MODULE: ./components/image/Image.tsx


var Image = function(param) {
    var src = param.src, alt = param.alt, onClick = param.onClick, className = param.className, dimension = param.dimension;
    var isUrl = (src === null || src === void 0 ? void 0 : src.includes("http")) || (src === null || src === void 0 ? void 0 : src.includes("https"));
    var unit = (dimension === null || dimension === void 0 ? void 0 : dimension.unit) || "px";
    var width = (dimension === null || dimension === void 0 ? void 0 : dimension.width) || 50;
    var height = (dimension === null || dimension === void 0 ? void 0 : dimension.height) || 50;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isUrl && src && // eslint-disable-next-line @next/next/no-img-element
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                alt: alt,
                onClick: onClick,
                className: className,
                width: width + unit,
                height: height + unit
            }),
            !isUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceHolder, {
                dimension: dimension,
                alt: alt,
                onClick: onClick
            })
        ]
    });
};


/***/ }),

/***/ 22411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ TableColumnWithImageAndText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47411);
/* harmony import */ var components_image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    text-align: left;\n    margin-left: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledTableColumnWithImageAndTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-549be504-0"
})(_templateObject());
var StyledTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-549be504-1"
})(_templateObject1());
var TableColumnWithImageAndText = function(param) {
    var image = param.image, imageAlt = param.imageAlt, onClick = param.onClick, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTableColumnWithImageAndTextContainer, {
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
                src: image,
                alt: imageAlt,
                className: className
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextContainer, {
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 2766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatTier; },
/* harmony export */   "Z": function() { return /* binding */ formatSecondsToMinutesAndSeconds; }
/* harmony export */ });
function formatSecondsToMinutesAndSeconds(s) {
    return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
}
var formatTier = function(tier) {
    var collectionLabel = tier.maxCollections === 1 ? "Collection" : "Collections";
    var trackLabel = tier.maxTracksInCollection === 1 ? "Track" : "Tracks";
    if (tier.includesPaidOption) {
        var paidCollectionLabel = tier.paidMaxCollections === 1 ? "Collection" : "Collections";
        var paidTrackLabel = tier.paidMaxTracksInCollection === 1 ? "Track" : "Tracks";
        return "".concat(tier.name, " (").concat(tier.maxCollections, " ").concat(collectionLabel, ", ").concat(tier.maxTracksInCollection, " ").concat(trackLabel, ",\n            ").concat(tier.paidMaxCollections, " paid ").concat(paidCollectionLabel, ", ").concat(tier.paidMaxTracksInCollection, " paid ").concat(paidTrackLabel, ")");
    }
    return "".concat(tier.name, " (").concat(tier.maxCollections, " ").concat(collectionLabel, ", ").concat(tier.maxTracksInCollection, " ").concat(trackLabel, ")");
};


/***/ })

}]);